import { Box } from '@mui/material';
import React from 'react';
import AuthLeftCard from '../../../shared/components/AuthLeftCard';
import ForgotEmailForm from './components/ForgotEmailForm';
import ForgotForm from './components/ForgotForm';

interface IProps {
  isOtp?: boolean;
}

const ForgotPassword = ({ isOtp = false }: IProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        width: '100vw',
      }}
    >
      {/* Left side */}
      <AuthLeftCard />
      {/* Right side */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {isOtp ? <ForgotForm /> : <ForgotEmailForm />}
      </Box>
    </Box>
  );
};

export default ForgotPassword;
